module.exports = __webpack_public_path__ + "img/form.80094d63.png";